import React, { PureComponent, useRef, useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import errorBoundary from '@ifeng-fe/errorBoundary';
import styles from './index.css';

class Nav extends PureComponent {
    static propTypes = {
        content: PropTypes.array,
    };

    render() {
        const { content } = this.props;

        return (
            <div className={styles.nav}>
                <div className={styles.nav_wrap}>
                    <div className={styles.nav_box}>
                        <ul>
                            {content.map((item, index) => {
                                return (
                                    <li key={index}>
                                        <span
                                            className={styles[`nav0${index + 1}`]}
                                            style={{ backgroundImage: `url(${content[0].src})` }}>
                                            <a
                                                href={item.url}
                                                target={index === 0 ? '_blank' : '_self'}
                                                style={{ backgroundImage: `url(${content[0].src})` }}>
                                                {item.title}
                                            </a>
                                        </span>
                                    </li>
                                );
                            })}
                        </ul>
                        <form
                            id="search_form"
                            method="get"
                            action="http://search.ifeng.com/sofeng/search.action"
                            target="_blank">
                            <div className={styles.search}>
                                <input
                                    type="text"
                                    id="sousuo"
                                    name="q"
                                    placeholder="按活动时间、地点、关键词搜索"
                                    className={styles.searchInp}
                                />
                                <input name="" type="submit" value="" className={styles.searchBtn} />
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        );
    }
}

export default errorBoundary(Nav);
